import mock from '@/fake-db/mock.js'

const data = {
  orders: [
    {
      'id': 268,
      'username': 'adoptionism744',
      'avatar': require('@/assets/images/portrait/small/avatar-s-3.jpg'),
      'email': 'angelo@sashington.com',
      'name': 'Angelo Sashington',
      'dob': '28 January 1998',
      'gender': 'male',
      'country': 'Bolivia',
      'role': 'admin',
      'status': 'active',
      'is_verified': true,
      'department': 'sales',
      'company': 'WinDon Technologies Pvt Ltd',
      'mobile': '+65958951757',
      'website': 'https://rowboat.com/insititious/Angelo',
      'languages_known': ['English', 'Arabic'],
      'contact_options': ['email', 'message', 'phone'],
      'location': {
        'add_line_1': 'A-65, Belvedere Streets',
        'add_line_2': '',
        'post_code': '1868',
        'city': 'New York',
        'state': 'New York',
        'country': 'United States'
      },
      'social_links': {
        'twitter': 'https://twitter.com/adoptionism744',
        'facebook': 'https://www.facebook.com/adoptionism664',
        'instagram': 'https://www.instagram.com/adopt-ionism744/',
        'github': 'https://github.com/madop818',
        'codepen': 'https://codepen.io/adoptism243',
        'slack': '@adoptionism744'
      },
      'permissions': {
        'users': {
          'read': true,
          'write': false,
          'create': false,
          'delete': false
        },
        'posts': {
          'read': true,
          'write': true,
          'create': true,
          'delete': true
        },
        'comments': {
          'read': true,
          'write': false,
          'create': true,
          'delete': false
        }
      }
    }
  ]
}


mock.onGet('/api/order-management/orders').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.orders)).reverse()]
})

// GET: Fetch Single User Details
mock.onGet(/\/api\/order-management\/orders\/\d+/).reply((request) => {

  const orderId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const order = data.orders.find((order) => order.id == orderId)

  return order ? [200, JSON.parse(JSON.stringify(order))] : [404]
})
mock.onDelete(/\/api\/order-management\/orders\/\d+/).reply((request) => {

  const orderId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.orders.findIndex((p) => p.id == orderId)
  data.orders.splice(itemIndex, 1)
  return [200]
})
